/* eslint-disable react-refresh/only-export-components */
import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Switch, Tooltip } from 'antd';
import classNames from 'classnames';
import useDarkMode from '../../../utils/hooks/useDarkMode';
import './styles.scss';

import { authState } from '../../../app/auth/authSlice';

function ModeSwitcher() {
  const { t } = useTranslation();
  const [isEnabled, setIsDark] = useDarkMode();
  const onSwitchChange = useCallback(
    (checked: boolean) => {
      setIsDark(checked ? 'dark' : 'light');
    },
    [setIsDark]
  );
  const { profile } = useSelector(authState);

  return (
    <div className="switch">
      <Tooltip
        title={
          isEnabled ? `${t('lightMode.tooltip')}` : `${t('darkMode.tooltip')}`
        }
      >
        <Switch
          checkedChildren="Light"
          unCheckedChildren="Dark"
          className={classNames({
            'pointer-events-none': profile?.user_settings?.guided_tour,
          })}
          onChange={onSwitchChange}
          style={{ width: 72 }}
          defaultChecked={isEnabled}
          checked={isEnabled}
        />
      </Tooltip>
    </div>
  );
}

export default memo(ModeSwitcher);
